var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDefaultAvatarEscalation = function SvgDefaultAvatarEscalation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#D6E9E4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00918A",
    fillRule: "nonzero",
    stroke: "#00918A",
    strokeWidth: 0.5,
    d: "M30.129 22.825a.958.958 0 0 0-.697-.273h-8.391c-1.24 0-1.24 1.945 0 1.945h6.107L15.88 35.813c-.194.194-.271.389-.271.544-.04.273.038.545.27.817 3.834 3.694 9.216 5.289 14.404 3.966 9.525-2.45 14.248-13.688 9.37-22.243-4.956-8.594-16.727-9.916-23.735-3.15-.89.856.465 2.255 1.355 1.361 3.834-3.733 9.525-4.939 14.481-2.8 4.801 2.061 7.937 6.922 7.937 12.133 0 5.21-3.174 10.072-7.937 12.133-4.646 2.022-9.95 1.05-13.745-2.139l10.493-10.538v6.124c0 1.244 1.936 1.244 1.936 0v-8.535a.832.832 0 0 0-.31-.661z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultAvatarEscalation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/default-avatar--escalation.a0c2557ff0d433544c346aefaa082089.svg";